import { Injectable, inject } from '@angular/core';
import {
  ProjectServiceCreateRequest,
  ProjectServiceCreateResponse,
  ProjectServiceCreateResponseSchema,
  ProjectServiceGetResponseSchema,
  ProjectServiceListRequest,
  ProjectServiceUpdateRequest,
  ProjectServiceUpdateResponseSchema,
} from '@vmspdb/definitions';
import { ConnectProject } from '@vmspdb/ui/connect';
import { ApiPaginated } from '@vmspdb/ui/domain';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRepositoryService } from './api-repository.service';
import { reencode } from './reencode';

@Injectable({
  providedIn: 'root',
})
export class ProjectRepositoryService implements ApiRepositoryService<
  ProjectServiceCreateRequest,
  ProjectServiceUpdateRequest,
  ProjectServiceListRequest,
  ProjectServiceCreateResponse
> {
  private api = inject(ConnectProject);

  create(
    data: ProjectServiceCreateRequest,
  ): Observable<ProjectServiceCreateResponse> {
    return this.api.create(data).pipe();
  }

  delete(uuid: string): Observable<void> {
    return this.api.delete({ uuid }).pipe(
      map(() => {
        return;
      }),
    );
  }

  sync(uuid: string): Observable<void> {
    return this.api.sync({ uuid }).pipe(
      map(() => {
        return;
      }),
    );
  }

  fetch(uuid: string): Observable<ProjectServiceCreateResponse> {
    return this.api
      .get({ uuid })
      .pipe(
        map((res) =>
          reencode(
            ProjectServiceGetResponseSchema,
            ProjectServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }

  list(
    request: ProjectServiceListRequest,
  ): Observable<ApiPaginated<ProjectServiceCreateResponse>> {
    return this.api.list(request);
  }

  update(
    data: ProjectServiceUpdateRequest,
  ): Observable<ProjectServiceCreateResponse> {
    return this.api
      .update(data)
      .pipe(
        map((res) =>
          reencode(
            ProjectServiceUpdateResponseSchema,
            ProjectServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }

  nextJobNumber() {
    return this.api.getNextJobNumber({});
  }
}
